import React, { useState, useEffect } from 'react';
import './FreeChat.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ChatInterface from './ChatInterface';
import { useNavigate } from 'react-router-dom';

export default function FreeChat() {
  const [showChat, setShowChat] = useState(false);
  const navigate = useNavigate();

  // Prevent body scrolling when chat is open
  useEffect(() => {
    if (showChat) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup function to restore scrolling when component unmounts
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showChat]);

  return (
    <div className="free-chat-page page-with-header">
      <Header />

      {/* Main Free Chat Section */}
      <section className="free-chat-section">
        <div className="free-chat-content">
          {/* Chat Illustration */}
          <div className="chat-illustration">
            <div className="person-left">
              <div className="person-avatar person-1">
                <div className="person-hair dark-hair"></div>
                <div className="person-face">
                  <div className="person-eyes">
                    <div className="eye"></div>
                    <div className="eye"></div>
                  </div>
                  <div className="person-mouth"></div>
                </div>
                <div className="person-body blue-shirt"></div>
                <div className="person-phone">
                  <div className="phone-screen">
                    <div className="typing-dots">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="speech-bubble left-bubble">
                <div className="bubble-dots">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </div>
            </div>

            <div className="person-right">
              <div className="person-avatar person-2">
                <div className="person-hair light-hair"></div>
                <div className="person-face">
                  <div className="person-eyes">
                    <div className="eye"></div>
                    <div className="eye"></div>
                  </div>
                  <div className="person-mouth"></div>
                </div>
                <div className="person-body orange-shirt"></div>
                <div className="person-phone">
                  <div className="phone-screen">
                    <div className="typing-dots">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="speech-bubble right-bubble">
                <div className="bubble-dots">
                  <div className="dot"></div>
                  <div className="dot"></div>
                  <div className="dot"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Message */}
          <div className="main-message">
            <h1 className="message-title">Tìm thấy sự chữa lành với AI của chúng tôi, từ bất cứ đâu trên thế giới.</h1>
            <p className="message-subtitle">Điều khoản & Chính sách bảo mật</p>
          </div>

          {/* Call to Action Button */}
          <div className="cta-section">
            <button 
              className="start-messaging-btn"
              onClick={() => navigate('/free-chat/messenger')}
            >
              Bắt đầu trò chuyện
            </button>
          </div>

          {/* Floating Computer Icon */}
          <div className="floating-computer-icon">
            <div className="computer-monitor">
              <div className="monitor-screen">
                <div className="screen-people">
                  <div className="person-silhouette person-1-silhouette"></div>
                  <div className="person-silhouette person-2-silhouette"></div>
                </div>
              </div>
              <div className="monitor-base orange-base"></div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* Chat Interface Modal */}
      {showChat && (
        <ChatInterface onClose={() => setShowChat(false)} />
      )}
    </div>
  );
}

